exports.FLATFILE_EMBED_TYPE = {
    USER: {
        EMBED_ID: process.env.USER_EMBED_ID,
        PRIVATE_KEY: process.env.USER_FLAT_FILE_PRIVATE_KEY
    },
    FLOOR: {
        EMBED_ID: process.env.FLOOR_EMBED_ID,
        PRIVATE_KEY: process.env.FLOOR_FLAT_FILE_PRIVATE_KEY
    },
    AREA: {
        EMBED_ID: process.env.AREA_EMBED_ID,
        PRIVATE_KEY: process.env.AREA_FLAT_FILE_PRIVATE_KEY
    },
    ROOM: {
        EMBED_ID: process.env.ROOM_EMBED_ID,
        PRIVATE_KEY: process.env.ROOM_FLAT_FILE_PRIVATE_KEY
    }
};